// extracted by mini-css-extract-plugin
export default {"containerVerticalBar":"VerticalBar_containerVerticalBar__EB7S0"};